var id = 0;
export default function _classPrivateFieldKey(name) {
  return "__private_" + id++ + "_" + name;
}